module.exports = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  mlEndpointURL: process.env.REACT_APP_ML_ENDPOINT || "https://us-central1-sharpend.cloudfunctions.net/automl-proxy"
};
